import { virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, ButtonText, ModalDialog, showDialog } from "#skyward_modalLayer";
import { insertTextToken } from "./skyward.base.global.text";
import { registerEvents } from "./skyward.ui.events";
import { getSelectedFieldData } from "./skyward.ui.treebrowse";

export interface BindingDialogOptions
{
    title: string;
    renderProxies: boolean;
    removeBaseFromBinding: boolean;
    onGetBinding(binding: string): void;
    onCancel(): void;
    anchorTo?: JQuery<HTMLElement>;
}

const classNames =
{
    bindingButton: "js-bindingButton",
    bindingButtonUnbound: "js-bindingButtonUnbound",
    bindingDialogSave: "js-bindingDialogSave"
};

const events =
{
    bindingButtonClick
};

registerEvents("binding", events);

const defaultSettings: BindingDialogOptions =
{
    title: "Insert Field",
    renderProxies: false,
    removeBaseFromBinding: false,
    onGetBinding: function (/*Binding*/) { },
    onCancel: function () { }
};

function bindingButtonClick(this: JQuery<HTMLElement>)
{
    const bindingButton = $(this);

    type BindingButtonData = {
        bindingTargetSelector: string;
        bindingValueOverride: string;
        bindingModule: string;
        bindingObject: string;
        removeBaseFromBinding: boolean;
        addSpace: boolean;
    }

    const bindingButtonData = bindingButton.data() as BindingButtonData;

    if (bindingButtonData.bindingTargetSelector && bindingButtonData.bindingValueOverride)
    {
        insertTextToken($(bindingButtonData.bindingTargetSelector), bindingButtonData.bindingValueOverride, bindingButtonData.addSpace);
    }

    if (!bindingButtonData.bindingModule || !bindingButtonData.bindingObject)
    {
        return;
    }

    const settings =
    {
        onGetBinding: function (binding: string)
        {
            if (bindingButtonData.bindingTargetSelector)
            {
                insertTextToken($(bindingButtonData.bindingTargetSelector), binding, bindingButtonData.addSpace);
            }
        },
        removeBaseFromBinding: bindingButtonData.removeBaseFromBinding
    };

    openBindingDialog(bindingButtonData.bindingModule, bindingButtonData.bindingObject, settings);
}

export function openBindingDialog(module: string, object: string, options: Partial<BindingDialogOptions>)
{
    const settings = $.extend({}, defaultSettings, options);

    const saveButtonDefinition: ButtonDefinition =
    {
        text: ButtonText.Select,
        icon: ButtonIcon.Select,
        click: onSaveClick,
        additionalClasses: classNames.bindingDialogSave
    };
    const cancelButtonDefinition: ButtonDefinition =
    {
        text: ButtonText.Cancel,
        icon: ButtonIcon.Cancel,
        click: onCancelClick
    };

    const bindingDialog = showDialog(settings.title, buildTreePopup(module, object, settings), [saveButtonDefinition, cancelButtonDefinition], settings);
    const saveButton = bindingDialog.footer.find(`.${classNames.bindingDialogSave}`);
    bindingDialog.content.on("treeBrowseSave", onSaveClick);
    bindingDialog.content.on("treeBrowseRowChange", function (_element, _treeBrowseData, row)
    {
        saveButton.toggle(!row.isRelationship);
    });

    function onSaveClick()
    {
        const binding = getBindingFromTree(bindingDialog, settings);
        bindingDialog.close();
        settings.onGetBinding(binding);
    }

    function onCancelClick()
    {
        bindingDialog.close();
        settings.onCancel();
    }
}

function buildTreePopup(module: string, object: string, options: BindingDialogOptions)
{
    return $.ajax({
        url: `${virtualDir}SkySys/Binding/BuildTreeBrowse/`,
        type: "POST",
        dataType: "viewparthtml",
        data:
        {
            module: module,
            object: object,
            renderProxies: options.renderProxies
        }
    });
}

function getBindingFromTree(modalLayer: ModalDialog, options: BindingDialogOptions)
{
    const bindingData = getSelectedFieldData(modalLayer.content);

    if (!bindingData || !bindingData.fieldName || !bindingData.fieldType)
    {
        return formatBinding("");
    }

    if (bindingData.fieldType.toString() != "ManyToOne")
    {
        let fieldName = bindingData.fieldName;

        if (options.removeBaseFromBinding)
        {
            const dotIndex = bindingData.fieldName.indexOf(".");
            fieldName = dotIndex <= 0 ? bindingData.fieldName : bindingData.fieldName.substring(dotIndex + 1, bindingData.fieldName.length);
        }

        return formatBinding(fieldName);
    }

    return formatBinding("");
}

function formatBinding(fieldName: string)
{
    return `{${fieldName}}`;
}
